import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-clock",
  "use": "icon-cl-clock-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-clock\"><path d=\"M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8Zm0 1.2c3.763 0 6.8 3.037 6.8 6.8s-3.037 6.8-6.8 6.8A6.79 6.79 0 0 1 1.2 8 6.79 6.79 0 0 1 8 1.2Zm-.61 1.991a.6.6 0 0 0-.59.609v4.4a.6.6 0 0 0 .176.424l2 2a.599.599 0 0 0 1.033-.421.601.601 0 0 0-.185-.427L8 7.952V3.8a.6.6 0 0 0-.61-.609Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol